module.exports = __webpack_public_path__ + "img/files-and-folders.594dfece.svg";